<template>
    <div class="petrhome-box">
        <div class="qunti-box ">
          <div class="head">
              <span class="head-title">工业产业投资方向及项目凝练</span>
          </div>
          <ul class="invest-nav">
              <li v-for="item in ditel" :key="item.id" class="invest-nav-item">
                  <router-link :to="{path: '/petrifaction',query: {id: item.id}}" class="link">
                      <img :src="`${domianURL}/${item.icoOne}`" class="icon default">
                      <img :src="`${domianURL}/${item.icoTwo}`" class="icon action">
                      <span class="text">{{ item.name }}</span>
                  </router-link>
              </li>
          </ul>
        </div>
        <img src="@/assets/image/policy/bg-1.png" alt="" class="pobg" />
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage.js";
export default {
  created() {
    this.loadData();
  },
  data() {
    return {
      ditel: [],
    };
  },
  methods: {
    loadData() {
      getAction("/sys/category/loadTreeByCode", {
        pid: "1356815807157448706",
      }).then((res) => {
        if (res.success) {
          this.ditel = res.result;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.petrhome-box{
    width: 92%;
    margin: 83px auto 50px;
    .qunti-box {
      -webkit-animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
      animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
    .head {
        background-color: #dca74e;
        border-radius: 18px;
        text-align: center;
        .head-title {
            font-size: 1.3rem;
            font-weight: bold;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 1px;
            color: #ffffff;
        }
    }
    .invest-nav{
        .invest-nav-item{
            height: 77px;
            position: relative;
            .link{
                position: absolute;
                bottom: 0;
                left: 20%;
                display: block;
                background: url(~@/assets/image/invest/invest_default.png) no-repeat top left;
                background-size: 100% 100%;
                width: 210px;
                height: 50px;
                line-height: 50px;
                box-sizing: border-box;
                padding-left: 10px;
                .icon{
                    width: 22px;
                    margin-right: 10px;
                    position: relative;
                    top: 3px;
                }
                .default{
                    display: inline-block;
                }
                .action{
                    display: none;
                }
                .text{
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                &:active{
                    background-image: url(~@/assets/image/invest/invest_click.png);
                    .text{
                        color: #fff;
                    } 
                    .default{
                        display: none;
                    }
                    .action{
                        display: inline-block;
                    }
                }
            }
            &::before{
                content: '';
                width: 1px;
                height: 90px;
                background:#DDAE5D;
                position: absolute;
                top: 0;
                left: 12%;
            }
            &::after{
                content: '';
                width: 1px;
                height: 33px;
                background: #DDAE5D;
                position: absolute;
                transform: rotateZ(-48deg);
                top: 39%;
                left: 15%;
            }
            &:nth-last-child(1){
                &::before{
                    height: 41px;
                }
            }
        }
    }
  }
  .pobg {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
</style>